import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Select,
  useDisclosure,
  SimpleGrid,
  Divider,
  useToast,
  Icon,
} from "@chakra-ui/react";
import {
  FaPlus,
  FaUser,
  FaUsersCog,
  FaUserCog,
  FaUserTie,
  FaUserGraduate,
  FaUserFriends,
  FaUsers,
  FaFingerprint,
  FaIdCard,
  FaCalendarAlt,
  FaCarSide,
  FaCar,
  FaClock,
  FaBus,
} from "react-icons/fa";
import axios from "axios";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Bus_Create_form = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const [vehicleNo, setVehicleNo] = useState("");
  const [vehicleModel, setVehicleModel] = useState("");
  const [madeOfYear, setMadeOfYear] = useState("");
  const [registrationNo, setRegistrationNo] = useState("");
  const [chassisNo, setChassisNo] = useState("");
  const [seatCapacity, setSeatCapacity] = useState("");
  const [minStudents, setMinStudents] = useState("");
  const [maxStudents, setMaxStudents] = useState("");
  const [driverId, setDriverId] = useState("");
  const [conductorId, setConductorId] = useState("");
  const [timeFromSchool, setTimeFromSchool] = useState("");
  const [timeToSchool, setTimeToSchool] = useState("");

  const [drivers, setDrivers] = useState([]);
  const [conductors, setConductors] = useState([]);

  useEffect(() => {
    fetchStaff();
  }, []);

  const fetchStaff = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/admin/bus/staff/list_all_bus_staff.php`,
        { params: { school_id: sessionStorage.getItem("school_id") } }
      );

      if (response.data.success) {
        const driverData = response.data.data.filter(
          (staff) => staff.staff_type === "Driver"
        );
        const conductorData = response.data.data.filter(
          (staff) => staff.staff_type !== "Driver"
        );

        setDrivers(driverData);
        setConductors(conductorData);
      } else {
        console.error("Failed to fetch staff");
      }
    } catch (error) {
      console.error("Error fetching staff:", error);
      toast({
        title: "Error",
        description: "There was an issue fetching the staff data.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleSubmit = async () => {
    const schoolId = sessionStorage.getItem("school_id"); // Get school ID from session
    const userId = sessionStorage.getItem("user_id"); // Get user ID from session

    // Function to format time into HH:mm (24-hour format)
    const formatTime = (time) => {
      const [hours, minutes] = time.split(":");
      let formattedTime = new Date();
      formattedTime.setHours(hours, minutes);
      return formattedTime.toTimeString().slice(0, 5); // Get HH:mm format
    };

    // Convert the time values to 24-hour format
    const formattedTimeFromSchool = formatTime(timeFromSchool);
    const formattedTimeToSchool = formatTime(timeToSchool);

    const busDetails = {
      user_id: userId,
      school_id: schoolId,
      bus_no: vehicleNo,
      reg_no: registrationNo,
      vehicle_model: vehicleModel,
      model_year: madeOfYear,
      chassis_no: chassisNo,
      seat_capacity: seatCapacity,
      min_students: minStudents,
      max_students: maxStudents,
      driver_id: driverId,
      conductor_id: conductorId,
      time_from_school: formattedTimeFromSchool,
      time_to_school: formattedTimeToSchool,
    };
    console.log("vehicle create", busDetails);

    try {
      const response = await fetch(
        `${BASE_URL}/admin/bus/vehicle/create_bus_details.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(busDetails),
        }
      );
      const result = await response.json();
      console.log("res in vehicle backend data:", result);

      if (result.success) {
        toast({
          title: "Success",
          description: "Bus details created successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        onClose(); // Close the modal on success
      } else {
        // Handle specific error messages from PHP validation
        if (result.message === "This Bus Details Already Exists") {
          toast({
            title: "Error",
            description: "This bus details already exist.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        } else if (
          result.message === "The Driver is Already Assigned to Another Bus"
        ) {
          toast({
            title: "Error",
            description: "The driver is already assigned to another bus.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        } else if (
          result.message === "The Conductor is Already Assigned to Another Bus"
        ) {
          toast({
            title: "Error",
            description: "The conductor is already assigned to another bus.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        } else {
          toast({
            title: "Error",
            description: result.message || "Failed to create bus details.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      }
    } catch (error) {
      toast({
        title: "Error",
        description: error.message || "Failed to create bus details.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <Button
        leftIcon={<FaPlus />}
        size={{ base: "xs", md: "md" }}
        colorScheme="purple"
        onClick={onOpen}
      >
        Vehicle
      </Button>

      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            <Icon as={FaPlus} boxSize={5} mr={2} />
            Add New Vehicle
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
              <FormControl id="vehicleNo">
                <FormLabel>
                  {" "}
                  <Icon as={FaBus} mr={1} color="teal.500" />
                  Vehicle No
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  type="text"
                  placeholder="Enter Vehicle Number"
                  value={vehicleNo}
                  onChange={(e) => setVehicleNo(e.target.value)}
                />
              </FormControl>

              <FormControl id="vehicleModel">
                <FormLabel>
                  {" "}
                  <Icon as={FaCarSide} mr={1} color="teal.500" />
                  Vehicle Model
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  type="text"
                  placeholder="Enter Vehicle Model"
                  value={vehicleModel}
                  onChange={(e) => setVehicleModel(e.target.value)}
                />
              </FormControl>

              <FormControl id="madeOfYear">
                <FormLabel>
                  {" "}
                  <Icon as={FaCalendarAlt} mr={1} color="teal.500" />
                  Made of Year
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  placeholder="Select Year"
                  value={madeOfYear}
                  onChange={(e) => setMadeOfYear(e.target.value)}
                >
                  {Array.from({ length: 30 }, (_, i) => {
                    const year = new Date().getFullYear() - i;
                    return (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    );
                  })}
                </Select>
              </FormControl>

              <FormControl id="registrationNo">
                <FormLabel>
                  {" "}
                  <Icon as={FaIdCard} mr={1} color="teal.500" />
                  Registration No
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  type="text"
                  placeholder="Enter Registration No"
                  value={registrationNo}
                  onChange={(e) => setRegistrationNo(e.target.value)}
                />
              </FormControl>

              <FormControl id="chassisNo">
                <FormLabel>
                  {" "}
                  <Icon as={FaFingerprint} mr={1} color="teal.500" />
                  Chassis No
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  type="text"
                  placeholder="Enter Chassis Number"
                  value={chassisNo}
                  onChange={(e) => setChassisNo(e.target.value)}
                />
              </FormControl>

              <FormControl id="seatCapacity">
                <FormLabel>
                  {" "}
                  <Icon as={FaUsers} mr={1} color="teal.500" />
                  Seat Capacity
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  type="number"
                  placeholder="Enter Seat Capacity"
                  value={seatCapacity}
                  onChange={(e) => setSeatCapacity(e.target.value)}
                />
              </FormControl>

              <FormControl id="minStudents">
                <FormLabel>
                  {" "}
                  <Icon as={FaUserGraduate} mr={1} color="teal.500" />
                  Min Students
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  type="number"
                  placeholder="Enter Minimum Students"
                  value={minStudents}
                  onChange={(e) => setMinStudents(e.target.value)}
                />
              </FormControl>

              <FormControl id="maxStudents">
                <FormLabel>
                  {" "}
                  <Icon as={FaUserFriends} mr={1} color="teal.500" />
                  Max Students
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  type="number"
                  placeholder="Enter Maximum Students"
                  value={maxStudents}
                  onChange={(e) => setMaxStudents(e.target.value)}
                />
              </FormControl>
            </SimpleGrid>

            <Divider mt={5} mb={5} />

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
              <FormControl id="timeFromSchool">
                <FormLabel>
                  {" "}
                  <Icon as={FaClock} mr={1} color="teal.500" />
                  Time From School
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  type="time"
                  value={timeFromSchool}
                  onChange={(e) => setTimeFromSchool(e.target.value)}
                />
              </FormControl>

              <FormControl id="timeToSchool">
                <FormLabel>
                  {" "}
                  <Icon as={FaClock} mr={1} color="teal.500" />
                  Time To School
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  type="time"
                  value={timeToSchool}
                  onChange={(e) => setTimeToSchool(e.target.value)}
                />
              </FormControl>
            </SimpleGrid>

            <Divider mt={5} />

            <FormLabel mt={6} fontWeight="bold">
              <Icon as={FaUsersCog} mr={1} color="teal.500" /> Driver and
              Conductor Details
            </FormLabel>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
              <FormControl id="selectDriver">
                <FormLabel>
                  {" "}
                  <Icon as={FaUserCog} mr={1} color="teal.500" />
                  Select Driver
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  placeholder="Select Driver"
                  value={driverId}
                  onChange={(e) => setDriverId(e.target.value)}
                >
                  {drivers.map((driver) => (
                    <option key={driver.id} value={driver.id}>
                      {driver.name}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl id="selectConductor">
                <FormLabel>
                  {" "}
                  <Icon as={FaUserTie} mr={1} color="teal.500" />
                  Select Conductor
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  placeholder="Select Conductor"
                  value={conductorId}
                  onChange={(e) => setConductorId(e.target.value)}
                >
                  {conductors.map((conductor) => (
                    <option key={conductor.id} value={conductor.id}>
                      {conductor.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </SimpleGrid>
          </ModalBody>

          <ModalFooter>
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              mr={3}
              onClick={handleSubmit}
            >
              Add New Vehicle
            </Button>
            {/* <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default Bus_Create_form;
